export default __webpack_public_path__ + "static/media/Ellipse19.fc226dad.png";